import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, withXhr } from "@angular/common/http";
import { importProvidersFrom, ErrorHandler, ApplicationConfig } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withRouterConfig } from "@angular/router";
import { MsalModule, MsalInterceptor, MsalGuard } from "@azure/msal-angular";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { TranslateModule } from "@ngx-translate/core";
import { APP_ROUTES } from "./app.routing";
import { LocaleProvider } from "./locale.provider";
import { AuthInterceptor } from "./shared/auth/auth-interceptor";
import { CanActivatAuthGuard } from "./shared/auth/can-activate-guard.service";
import { CoreModule } from "./shared/core.module";
import { MSALConfig, B2CPolicies } from "./shared/models/auth-config.model";
import { GlobalErrorHandlerService } from "./shared/services/global-error-handler.service";

export const appConfig: ApplicationConfig = {
    providers: [
      // In v22 il default è 'always': manteniamo il comportamento pre-22 (i figli non ereditano i param del padre)
      provideRouter(APP_ROUTES, withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
      provideAnimations(),
      provideHttpClient(withXhr(), withInterceptorsFromDi()),
  
      // Modules that expose providers via .forRoot()
      importProvidersFrom(
        CoreModule.forRoot(),
        TranslateModule.forRoot(),
        MsalModule.forRoot(
          new PublicClientApplication(MSALConfig()),
          {
            interactionType: InteractionType.Redirect,
            authRequest: {
              scopes: [B2CPolicies().scope]
            }
          },
          {
            interactionType: InteractionType.Redirect,
            protectedResourceMap: new Map([])
          }
        ),
      ),
  
      // App-level providers
      LocaleProvider,
      { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },
      MsalGuard,
      CanActivatAuthGuard,
    ]
  }